var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnNftflip = function SvgIcnNftflip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.956 1.258a1.9 1.9 0 0 0-1.912 0L2.956 4.796A1.926 1.926 0 0 0 2 6.462v7.076c0 .687.364 1.322.956 1.666l6.088 3.538a1.9 1.9 0 0 0 1.912 0l6.088-3.538c.592-.344.956-.979.956-1.666V6.462c0-.687-.364-1.322-.956-1.666l-6.088-3.538ZM8.368 4.79h2.753a.16.16 0 0 1 .148.219l-1.077 2.778a.16.16 0 0 0 .187.214l2.854-.718a.16.16 0 0 1 .179.232L9.18 15.397c-.134.25-.512.1-.441-.174l1.278-4.98a.16.16 0 0 0-.182-.198l-3.007.55a.16.16 0 0 1-.181-.202l1.568-5.487a.16.16 0 0 1 .153-.116Z",
    fill: "#595959"
  })));
};
export default SvgIcnNftflip;